/* eslint-disable indent */
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { useToasts } from 'react-toast-notifications'
import { Col, FormGroup, Input, Row } from 'reactstrap'
import deliveryApi from '_api/delivery'
import orderApi from '_api/order'
import TableHeaderWithSort from '_components/TableHeaderWithSort'
import {
  updateDeliveryCombinedPayment,
  updateDeliveryPaymentStatusDesktop,
} from '_redux/modules/delivery'
import { getListCombinedPayment, updateOrderCombinedPayment } from '_redux/modules/event'
import {
  DELIVERY_BUYER_PAID,
  DELIVERY_BUYER_REFUND,
  DELIVERY_BUYER_UNPAID,
  DELIVERY_HOST_CANCELLED,
  DELIVERY_HOST_PAID,
  DELIVERY_HOST_UNPAID,
} from '_utils/constant'
import { handleDataOrder, handleDataOrderByPercentage } from '_utils/function'
import ModalDetailDelivery from '../../../pages/Event/components/ModalDetailDelivery'
import ModalMessage from '../../../pages/Event/components/ModalMessage'
import ModalPaymentScreen from '../../../pages/Event/components/ModalPaymentScreen'
import ModalWarning from '../../../pages/Event/components/ModalWarning'

function DeliveryList({ listDelivery, setSorting, setTimeReRender }) {
  const { addToast } = useToasts()
  const dispatch = useDispatch()
  const data = listDelivery

  const { eventAndOrderById, listCombinedPayments } = useSelector((state) => state.event)

  const headers = [
    {
      name: 'Name',
      field: 'uName',
      type: 'string',
      className: 'col col-auto',
      sortable: true,
    },
    {
      name: 'Mobile',
      field: 'uPhone',
      className: 'col col-auto',
      type: 'string',
      sortable: true,
    },
    {
      name: 'Date',
      field: 'createdAt',
      type: 'number',
      className: 'col col-auto',
      sortable: true,
    },
    {
      name: 'Purchase',
      field: 'dzName',
      type: 'string',
      className: 'col col-auto',
      sortable: true,
    },
    {
      name: 'Delivery Status',
      field: 'status',
      type: 'number',
      className: 'col col-auto text-center',
      sortable: true,
    },
    {
      name: 'Payment Status',
      field: 'bookerStatus',
      type: 'number',
      className: 'col col-auto text-center',
      sortable: true,
    },
    {
      name: 'Verified',
      field: 'status',
      type: 'number',
      className: 'col col-auto text-center',
      sortable: true,
    },
  ]

  const [modalMessage, setModalMessage] = useState(false)
  const [modalPaymentScreen, setModalPaymentScreen] = useState(false)
  const [modalDetail, setModalDetail] = useState(false)
  const [modalWarning, setModalWarning] = useState(false)
  const [dataModal, setDataModal] = useState({})
  const [dataModalDetail, setDataModalDetail] = useState({})

  const [loading, setLoading] = useState(true)

  const initListDelivery = async (_data) => {
    const listCombinedPaymentRef = []
    setLoading(true)
    _data?.forEach(async (element) => {
      const { combinedPaymentRef = '' } = element
      if (!listCombinedPaymentRef.includes(combinedPaymentRef)) {
        if (combinedPaymentRef) {
          listCombinedPaymentRef.push(combinedPaymentRef)
        }
      }
    })
    if (listCombinedPaymentRef.length) {
      await dispatch(getListCombinedPayment(listCombinedPaymentRef))
    }
    setLoading(false)
  }

  useEffect(() => {
    initListDelivery(listDelivery)
  }, [])

  const toggleMessage = () => setModalMessage(!modalMessage)

  const togglePaymentScreen = () => setModalPaymentScreen(!modalPaymentScreen)

  const toggleDetail = () => {
    setModalDetail(!modalDetail)
  }

  const toggleWarning = () => setModalWarning(!modalWarning)

  const updateDeliveryBookingStatus = async (_ref, _data, _id) => {
    dispatch(updateDeliveryPaymentStatusDesktop(_id, _ref, _data.status, _data.bookerStatus))
    await deliveryApi.updateDeliveryBookingStatus(_ref, _data, _id)
    // setTimeReRender((prevState) => prevState + 1)
  }

  const updateDeliveryBookerStatus = async (_ref, _data) => {
    dispatch(updateDeliveryPaymentStatusDesktop(_ref, _data.status, _data.bookerStatus))
    await deliveryApi.updateDeliveryBookerStatus(_ref, { bookerStatus: _data.bookerStatus })
    setTimeReRender((prevState) => prevState + 1)
  }

  const updateDeliveryCombinedPaymentAPI = async (_data) => {
    dispatch(
      updateDeliveryCombinedPayment(_data.combinedPaymentRef, _data.status, _data.placerStatus)
    )
    dispatch(updateOrderCombinedPayment(_data.combinedPaymentRef, _data.status, _data.placerStatus))
    await orderApi.updateInvoicesStatus(_data)
    setTimeReRender((prevState) => prevState + 1)
  }

  const onChangeSelect = async (e, _ref, _status, _bookerStatus, _combinedPaymentRef, _id) => {
    try {
      if (_status === DELIVERY_HOST_UNPAID && Number(e.target.value) === DELIVERY_HOST_PAID) {
        const _data = { status: Number(e.target.value), bookerStatus: DELIVERY_BUYER_PAID }
        await updateDeliveryBookingStatus(_ref, _data, _id)
      } else if (
        _status !== DELIVERY_HOST_CANCELLED &&
        Number(e.target.value) === DELIVERY_HOST_CANCELLED &&
        _bookerStatus > DELIVERY_BUYER_UNPAID
      ) {
        if (_combinedPaymentRef) {
          const _data = {
            combinedPaymentRef: _combinedPaymentRef,
            status: Number(e.target.value),
            placerStatus: DELIVERY_BUYER_REFUND,
          }
          await updateDeliveryCombinedPaymentAPI(_data)
        } else {
          const _data = { status: Number(e.target.value), bookerStatus: DELIVERY_BUYER_REFUND }
          await updateDeliveryBookingStatus(_ref, _data, _id)
        }
      } else if (
        _status === DELIVERY_HOST_CANCELLED &&
        Number(e.target.value) !== DELIVERY_HOST_CANCELLED &&
        _bookerStatus === DELIVERY_BUYER_REFUND
      ) {
        const _data = { status: Number(e.target.value), bookerStatus: DELIVERY_BUYER_PAID }
        await updateDeliveryBookingStatus(_ref, _data, _id)
      } else {
        const _data = { status: Number(e.target.value), bookerStatus: _bookerStatus }
        await updateDeliveryBookingStatus(_ref, _data, _id)
      }
    } catch (error) {
      const { msgResp } = error
      addToast(msgResp, { appearance: 'error', autoDismiss: true })
      // setTimeReRender((prevState) => prevState + 1)
    }
  }

  const openMessageModal = (e, order) => {
    e.preventDefault()
    setDataModal(order)
    toggleMessage()
  }

  const openPaymentScreen = (e, delivery) => {
    e.preventDefault()

    const { combinedPaymentRef } = delivery
    let listCombinedOrder = []
    let listCombinedDelivery = []

    if (combinedPaymentRef) {
      const exitCombinedPayment = listCombinedPayments?.findIndex(
        (item) => item.combinedPaymentRef === combinedPaymentRef
      )

      if (exitCombinedPayment !== -1) {
        const { orderCombinedPayment, deliveryCombinedPayment } =
          listCombinedPayments[exitCombinedPayment]

        orderCombinedPayment.forEach((element) => {
          const { eid, ref: elementRef } = element
          const { orders, adminCost, discount, deliveryCost, productIdList, isPercentage = false } =
            eventAndOrderById.find((item) => item.id === eid) || {}
          const { listOrder: otherListOrder } = isPercentage ? handleDataOrderByPercentage(
            orders,
            adminCost,
            discount,
            deliveryCost,
            productIdList
          ) : handleDataOrder(orders,
            adminCost,
            discount,
            deliveryCost,
            productIdList)

          const otherOrder = otherListOrder.find((item) => item.ref === elementRef)
          listCombinedOrder = [...listCombinedOrder, otherOrder]
        })
        listCombinedDelivery = [...deliveryCombinedPayment]
      }
    }

    setDataModal({ ...delivery, listCombinedOrder, listCombinedDelivery })
    togglePaymentScreen()
  }

  const handleInvalidPayment = async (_ref, _status, _combinedPaymentRef) => {
    try {
      const r = confirm('Are you sure this is invalid payment?')
      if (r === true) {
        if (_combinedPaymentRef) {
          const _data = {
            combinedPaymentRef: _combinedPaymentRef,
            status: DELIVERY_HOST_UNPAID,
            placerStatus: DELIVERY_BUYER_UNPAID,
          }
          await updateDeliveryCombinedPaymentAPI(_data)
        } else {
          const _data = { status: _status, bookerStatus: DELIVERY_BUYER_UNPAID }
          await updateDeliveryBookerStatus(_ref, _data)
        }
        togglePaymentScreen()
      }
    } catch (error) {
      const { msgResp } = error
      addToast(msgResp, { appearance: 'error', autoDismiss: true })
      togglePaymentScreen()
    }
  }

  const handleShowDetail = (e, delivery) => {
    e.preventDefault()
    setDataModalDetail(delivery)
    toggleDetail()
  }

  const handleCancel = async (e, _ref, _status, _bookerStatus, _combinedPaymentRef) => {
    e.preventDefault()
    try {
      if (_status !== DELIVERY_HOST_CANCELLED && _bookerStatus > DELIVERY_BUYER_UNPAID) {
        if (_combinedPaymentRef) {
          const _data = {
            combinedPaymentRef: _combinedPaymentRef,
            status: DELIVERY_HOST_CANCELLED,
            placerStatus: DELIVERY_BUYER_REFUND,
          }
          await updateDeliveryCombinedPaymentAPI(_data)
        } else {
          const _data = { status: DELIVERY_HOST_CANCELLED, bookerStatus: DELIVERY_BUYER_REFUND }
          await updateDeliveryBookingStatus(_ref, _data)
        }
        toggleDetail()
        toggleWarning()
      } else {
        const _data = { status: DELIVERY_HOST_CANCELLED, bookerStatus: _bookerStatus }
        await updateDeliveryBookingStatus(_ref, _data)
        toggleDetail()
        toggleWarning()
      }
    } catch (error) {
      const { msgResp } = error
      addToast(msgResp, { appearance: 'error', autoDismiss: true })
      toggleDetail()
      toggleWarning()
    }
  }

  const handleOpenWarning = (e, order) => {
    e.preventDefault()
    setDataModal(order)
    toggleWarning()
  }

  return (
    <div className='list-event'>
      <React.Fragment>
        <TableHeaderWithSort
          headers={headers}
          onSorting={(field, order, type) => setSorting({ field, order, type })}
          defaultSortingField='eOrderNo'
          defaultSortingOrder='asc'
          className={'row mx-0 p-3 bg-light fw-bold'}
          key='table-header'
        />
        {loading ? <div>Loading...</div> : null}
        {!loading && data && data.length > 0
          ? data.map((delivery, index) => (
              <Row
                key={index}
                className={`${
                  index % 2 !== 0 ? 'bg-light' : ''
                } list-event__item border-0 items-center p-3`}
              >
                <Col>
                  <Link
                    to='#'
                    style={{ color: '#7c797a' }}
                    onClick={(e) => handleShowDetail(e, delivery)}
                  >
                    {delivery.uName}
                  </Link>

                  {delivery.comment && (
                    <div className='d-flex align-items-center mt-3'>
                      <span className='me-2'>Note:</span>
                      <Link to='#' onClick={(e) => openMessageModal(e, delivery)}>
                        <i className='icon-new'></i>
                      </Link>
                    </div>
                  )}
                </Col>
                <Col>{delivery.uPhone}</Col>
                <Col>{moment(delivery.createdAt * 1000).format('DD/MM/YYYY')}</Col>
                <Col>Delivery: {delivery.dzName}</Col>
                <Col className='text-center'>
                  {delivery.status === DELIVERY_HOST_CANCELLED && <span>Refunded</span>}
                  {delivery.status === DELIVERY_HOST_UNPAID && <span>Not Paid</span>}
                  {delivery.status === DELIVERY_HOST_PAID && <span>Paid</span>}
                </Col>
                <Col className='text-center'>
                  {delivery.bookerStatus === DELIVERY_BUYER_UNPAID && (
                    <span className='n-paid' style={{ paddingRight: 0 }}>
                      Not Paid
                    </span>
                  )}
                  {delivery.bookerStatus === DELIVERY_BUYER_PAID && (
                    <a
                      href='#'
                      className={`${delivery?.combinedPaymentRef ? 'paid-combined' : 'paid'}`}
                      data-toggle='modal'
                      data-target='#modal-paid'
                      onClick={(e) => openPaymentScreen(e, delivery)}
                      style={{ fontSize: '12.5px' }}
                    >
                      Paid
                    </a>
                  )}
                  {delivery.bookerStatus === DELIVERY_HOST_CANCELLED && (
                    <span className=''>Cancelled</span>
                  )}
                  {delivery.bookerStatus === DELIVERY_BUYER_REFUND && (
                    <span className=''>Refunded</span>
                  )}
                </Col>
                <Col>
                  <FormGroup>
                    <Input
                      id='select'
                      name='select'
                      type='select'
                      className='form-control-payment'
                      value={delivery.status}
                      onChange={(e) =>
                        onChangeSelect(
                          e,
                          delivery.ref,
                          delivery.status,
                          delivery.bookerStatus,
                          delivery.combinedPaymentRef,
                          delivery.did
                        )
                      }
                      style={
                        delivery.status === DELIVERY_HOST_UNPAID
                          ? { color: '#ff6903' }
                          : delivery.status === DELIVERY_HOST_PAID
                          ? { color: '#51aaaa' }
                          : { color: '#7c797a' }
                      }
                    >
                      <option value={DELIVERY_HOST_CANCELLED}>Cancelled</option>
                      <option value={DELIVERY_HOST_UNPAID}>Unpaid</option>
                      <option value={DELIVERY_HOST_PAID}>Verified</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
            ))
          : null}
      </React.Fragment>
      {Object.keys(dataModal).length !== 0 && (
        <ModalMessage data={dataModal} modalMessage={modalMessage} toggleMessage={toggleMessage} />
      )}
      {Object.keys(dataModal).length !== 0 && (
        <ModalPaymentScreen
          data={dataModal}
          modalPaymentScreen={modalPaymentScreen}
          togglePaymentScreen={togglePaymentScreen}
          handleInvalidPayment={handleInvalidPayment}
        />
      )}
      {Object.keys(dataModal).length !== 0 && (
        <ModalWarning
          data={dataModal}
          title='delivery'
          modalWarning={modalWarning}
          toggleWarning={toggleWarning}
          handleCancel={handleCancel}
        />
      )}
      {Object.keys(dataModalDetail).length !== 0 && (
        <ModalDetailDelivery
          data={dataModalDetail}
          modalDetail={modalDetail}
          toggleDetail={toggleDetail}
          handleOpenWarning={handleOpenWarning}
          setTimeReRender={setTimeReRender}
        />
      )}
    </div>
  )
}

export default DeliveryList
